import { action, computed, observable, runInAction } from 'mobx';
import { bookingApi } from '@link/agent/services';
import { StartCancelReservationResponse } from '@link/agent/services/types';
import { BookingDetailBase } from '@link/share/stores';

export class BookingDetail extends BookingDetailBase {
  @observable accessor cancelInfo: StartCancelReservationResponse = {};

  async init(bookingCustomId: string) {
    const res = await this.getBooking(bookingCustomId);
    if (res?.booking?.id) {
      await this.getAllDiscrepancies(res.booking.id);
    }
  }

  @action
  getBooking(bookingCustomId: string) {
    return bookingApi.getBooking({ customId: bookingCustomId }).then(res => {
      runInAction(() => {
        this.bookingDetail = res;
      });
      return res;
    });
  }

  @action
  getAllDiscrepancies(bookingId: string) {
    return bookingApi.getAllDiscrepancies({ bookingId }).then(res => {
      runInAction(() => {
        this.discrepancyRequests = res?.discrepancyRequests || [];
      });
    });
  }
  // 失败时（不可取消等）接口返回 4xx 并抛出错误，由调用方按 error_code 处理
  @action
  startCancelReservation(bookingId: string) {
    return bookingApi.startCancelBooking({ body: { bookingId } }).then(res => {
      runInAction(() => {
        this.cancelInfo = res;
      });
    });
  }
  @computed
  get refundDetailToOta() {
    return this.cancelInfo.cancelRefundDisplay;
  }
  @computed
  get cancellationPolicy() {
    return this.cancelInfo.cancellationPolicy;
  }
}

export default new BookingDetail();
